import { SpaceMemberRole } from '../types/space';
export const getDocumentDeleteAccess = (access) => access.filter(({ role, grantedVia }) => grantedVia !== 'document' || role === SpaceMemberRole.ADMIN);
//# sourceMappingURL=getDocumentDeleteAccess.js.map